import React, { useEffect, useState, useCallback } from 'react';
import { toast } from 'react-toastify';
import { useAuth } from '../../context/AuthContext';
import { getApiErrorMessage } from '../../services/apiError';
import {
  getMyNotificationSettings,
  updateMyNotificationSetting,
} from '../../services/api';
import NotificationSettingsTable from '../../components/notifications/NotificationSettingsTable';
import styles from './MyNotificationSettings.module.css';

const MyNotificationSettings = () => {
  const { activeDerasarId } = useAuth();
  const [events, setEvents] = useState([]);
  const [channels, setChannels] = useState({ emailEnabled: true, whatsappEnabled: true });
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    if (!activeDerasarId) return;
    setLoading(true);
    try {
      const data = await getMyNotificationSettings(activeDerasarId);
      setEvents(data.events);
      if (data.channels) setChannels(data.channels);
    } catch (err) {
      toast.error(getApiErrorMessage(err, 'Failed to load your notification preferences'));
    } finally {
      setLoading(false);
    }
  }, [activeDerasarId]);

  useEffect(() => { load(); }, [load]);

  const onToggle = async (eventKey, channel, value) => {
    const patch = channel === 'email' ? { emailEnabled: value } : { whatsappEnabled: value };
    const prev = events;
    setEvents((list) => list.map((e) => (e.key === eventKey ? { ...e, ...patch } : e)));
    try {
      await updateMyNotificationSetting({ derasarId: activeDerasarId, eventKey, ...patch });
    } catch (err) {
      setEvents(prev);
      toast.error(getApiErrorMessage(err, 'Failed to update preference'));
    }
  };

  if (loading) return <div className={styles.loading}>Loading…</div>;

  return (
    <div>
      <div className="page-header">
        <h2>Notification Settings</h2>
        <p className={styles.subtitle}>
          Notifications you receive over Email &amp; WhatsApp for this derasar. In-app is always on;
          a greyed-out channel is turned off by your derasar or its template isn&apos;t ready yet.
        </p>
      </div>
      <div className="card">
        <div className="table-container">
          <NotificationSettingsTable
            events={events}
            onToggle={onToggle}
            channelDisabled={{ email: !channels.emailEnabled, whatsapp: !channels.whatsappEnabled }}
          />
        </div>
      </div>
    </div>
  );
};

export default MyNotificationSettings;
